module.exports = __webpack_public_path__ + "img/f6b7534.jpg";